import React, { useEffect, useState } from "react";
import "../dashboard/Profile/section/Privacy_policy.css";
import { toastMessage } from "../../utils/toastMessage";
import { fetchCmsDataApi } from "../../services/faqs";
import { fetchPublicCmsDataApi } from "../../services/common";
import Header from "../../components/header/Header";
import Footer from "../landingpage/section/Footer";
import "../faqs/Faq_terms.css";

const Terms = () => {
  const [termsData, setTermsData] = useState("");

  const getAboutHandler = async () => {
    try {
      const { data } = await fetchPublicCmsDataApi({ type: "TERMS" });
      const { data: terms, success, message } = data;
      if (success) {
        // toastMessage(message, "success", "terms");
        setTermsData(terms);
      }
    } catch (e) {
      console.log("Login:-", e.message);
    }
  };

  //   console.log(termsData, "termsData");

  useEffect(() => {
    getAboutHandler();
  }, []);

  return (
    <>
      <Header />

      <div className="Privacy_policy terms_condition">
        <div className="container_privacy_policy">
          {/* <div className="privacy_policy_heading">
            <h3>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.{" "}
            </h3>
             </div> */}

          <div className="custom_container">
            <div className="privacy_policy_title">
              <h2>Terms & Conditions</h2>
            </div>
            <p
              dangerouslySetInnerHTML={{
                __html: termsData?.description,
              }}
            ></p>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Terms;
